import React, { useEffect, useState } from "react";
import Layout from "../hocs/Layout";
import { connect } from "react-redux";
import { get_filters, get_store_alls } from "../redux/actions/store";
import StoreList from "../components/store/StoreList";
import Search from "../components/store/search";

const Store = ({ get_store_alls, array_store, get_filters, array_filters }) => {
    const [filters, setFilters] = useState({
        search: "",
        filter_id: "",
        page: 1,
    });
    const [stores, setStores] = useState([]);

    useEffect(() => {
        if (array_filters.length === 0) {
            get_filters();
        }
    }, [array_filters]);

    useEffect(() => {
        get_store_alls(filters);
    }, [filters]);

    useEffect(() => {
        setStores(array_store);
    }, [array_store]);

    const onSearchChange = (value) => {
        setFilters({
            search: value,
            filter_id: filters.filter_id,
            page: 1,
        });
    };

    const onFilterSelect = (filterId) => {
        setFilters({
            search: filters.search,
            filter_id: filterId,
            page: 1,
        });
    };


    const loadMore = () => {
        setFilters((prev) => ({
            ...prev,
            page: prev.page + 1,
        }));
    };

    return (
        <Layout>
            <main className="w-full min-h-screen bg-gray-50">
                <Search
                    filters={array_filters}
                    onSearchChange={onSearchChange}
                    onFilterSelect={onFilterSelect}
                />
                {stores.length > 0 ? (
                    <StoreList
                        array_store={stores}
                        loadMore={loadMore} />
                ) : (
                    /* Pulse skeleton while loading */
                    <div className="container py-8">
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                            {[...Array(8)].map((_, i) => (
                                <div key={i} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm animate-pulse">
                                    <div className="h-24 bg-gray-200" />
                                    <div className="p-4 pt-10">
                                        <div className="h-3 bg-gray-200 rounded w-3/4 mb-2" />
                                        <div className="h-2 bg-gray-100 rounded w-full mb-1" />
                                        <div className="h-2 bg-gray-100 rounded w-2/3" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </main>
        </Layout>
    );
};


const mapStateToProps = state => ({
    array_store: state.Store.array_store,
    array_filters: state.Store.array_filters,
});

export default connect(mapStateToProps, { get_store_alls, get_filters })(Store);
